import useSWR from 'swr'
import { ParticipantController } from '@/controllers'
import { config } from '@/config'
import { useMemo } from 'react'
import { ParticipantMetric } from '@/interfaces/participant'

const key = (participantId: number) => `${config.api.endpoints.participant.metrics}-for-${participantId}`

export const useSingleParticipantMetrics = (participantId: number) => {
  const {
    data,
    mutate,
    error: uncaughtError,
    isLoading,
    isValidating,
  } = useSWR(key(participantId), () => ParticipantController.metrics(participantId))
  const memoizedData = useMemo(() => {
    const metrics = data?.result?.[1]?.[participantId] || ({} as ParticipantMetric)
    const error = data?.result?.[0] || uncaughtError

    return { metrics, error }
  }, [data, uncaughtError])

  const revalidate = async () => {
    const response = await mutate()

    if (!response) {
      throw new Error('Failed to revalidate participants metrics')
    }

    return response.result
  }

  return {
    ...memoizedData,
    isLoading,
    revalidate,
    isValidating,
  }
}
